module.exports = __webpack_public_path__ + "static/media/maruti suzuki brezza.7fbb3fa1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/maruti suzuki brezza.gif
// module id = 141
// module chunks = 0